import React from 'react';

import { TableColumnSmxType } from '../../types';
import FieldColor from './fieldColor';
import FieldDate from './fieldDate';
import FieldNumber from './fieldNumber';
import FieldString from './fieldString';
import FieldTime from './fieldTime';

interface IInputWithValue {
    data: TableColumnSmxType;
}

const FormFieldByType: React.FC<IInputWithValue> = ({ data }) => {
    switch (data.typeDecode) {
        case 'Int':
            return <FieldNumber fieldData={data} />;
        case 'Date':
            return <FieldDate fieldData={data} />;
        case 'Time':
            return <FieldTime fieldData={data} />;
        case 'Color':
            return <FieldColor fieldData={data} />;
        case 'String':
        default:
            return <FieldString fieldData={data} />;
    }
};

export default FormFieldByType;
